import { Stack } from "@mui/material";
import { type FC } from "react";
import { NavLink } from "react-router";

import { ROUTES } from "~/constants/routing";

import { FOOTER_CATEGORIES } from "../../constants";
import * as Styled from "./FooterCategoryGrid.styles";

export const FooterCategoryGrid: FC = () => {
  return (
    <Stack>
      <Styled.Heading component="p">Markets by category</Styled.Heading>
      <Styled.Grid>
        {FOOTER_CATEGORIES.map(({ slug, name, sub }) => (
          <Styled.CategoryLink
            key={slug}
            component={NavLink}
            to={ROUTES.category.createURL(slug)}
          >
            <Styled.Name>{name}</Styled.Name>
            <Styled.Sub>{sub}</Styled.Sub>
          </Styled.CategoryLink>
        ))}
      </Styled.Grid>
    </Stack>
  );
};
